import { IModifiersContext, IFilterValues } from './modifiersContext';

export enum ModifiersActionTypes {
	SET_MODIFIERS = 'SET_MODIFIERS',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_ID_SELECTED_CUSTOMER = 'SET_ID_SELECTED_CUSTOMER',
	SET_ID_SELECTED_RESTAURANT = 'SET_ID_SELECTED_RESTAURANT',
	SET_ID_SELECTED_MODIFIER_GROUP = 'SET_ID_SELECTED_MODIFIER_GROUP',
	CHANGE_PRICE_FROM = 'CHANGE_PRICE_FROM',
	CHANGE_PRICE_TO = 'CHANGE_PRICE_TO',
	TOGGLE_SHOW_ONLY_COMBO_ITEMS = 'TOGGLE_SHOW_ONLY_COMBO_ITEMS',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	TOGGLE_IS_DISABLED_MODIFIERS = 'TOGGLE_IS_DISABLED_MODIFIERS',
	TOGGLE_IS_RESTRICTED_MODIFIERS = 'TOGGLE_IS_RESTRICTED_MODIFIERS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	SET_ID_FOR_FULL_INFO = 'SET_ID_FOR_FULL_INFO',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetModifiers {
	type: ModifiersActionTypes.SET_MODIFIERS;
	payload: {
		modifiers: IModifiersContext['modifiers'];
		typeOfModalWindow: IModifiersContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: ModifiersActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IModifiersContext['searchString'];
	};
}

interface ISetIDCustomer {
	type: ModifiersActionTypes.SET_ID_SELECTED_CUSTOMER;
	payload: {
		IDSelectedCustomer: IModifiersContext['IDSelectedCustomer'];
	};
}

interface ISetIDRestaurant {
	type: ModifiersActionTypes.SET_ID_SELECTED_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IModifiersContext['IDSelectedRestaurant'];
	};
}

interface ISetIDModifierGroup {
	type: ModifiersActionTypes.SET_ID_SELECTED_MODIFIER_GROUP;
	payload: {
		IDSelectedModifierGroup: IModifiersContext['IDSelectedModifierGroup'];
	};
}

interface IChangePriceFrom {
	type: ModifiersActionTypes.CHANGE_PRICE_FROM;
	payload: {
		priceFrom: IModifiersContext['priceFrom'];
	};
}

interface IChangePriceTo {
	type: ModifiersActionTypes.CHANGE_PRICE_TO;
	payload: {
		priceTo: IModifiersContext['priceTo'];
	};
}

interface IToggleShowOnlyComboItems {
	type: ModifiersActionTypes.TOGGLE_SHOW_ONLY_COMBO_ITEMS;
}

interface IResetSelectedControls {
	type: ModifiersActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: ModifiersActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IModifiersContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: ModifiersActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IModifiersContext['countOfItems'];
	};
}

interface IToggleIsDisabledModifiers {
	type: ModifiersActionTypes.TOGGLE_IS_DISABLED_MODIFIERS;
}

interface IToggleIsRestrictedModifiers {
	type: ModifiersActionTypes.TOGGLE_IS_RESTRICTED_MODIFIERS;
}

interface IChangeCurrentPage {
	type: ModifiersActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IModifiersContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: ModifiersActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IModifiersContext['IDForDeletion'];
		typeOfModalWindow: IModifiersContext['typeOfModalWindow'];
	};
}

interface ISetIDForFullInfo {
	type: ModifiersActionTypes.SET_ID_FOR_FULL_INFO;
	payload: {
		IDForFullInfo: IModifiersContext['IDForFullInfo'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ModifiersActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IModifiersContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: ModifiersActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TModifiersAction =
	| ISetModifiers
	| IChangeSearchString
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetIDModifierGroup
	| IChangePriceFrom
	| IChangePriceTo
	| IToggleShowOnlyComboItems
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IToggleIsDisabledModifiers
	| IToggleIsRestrictedModifiers
	| IChangeCurrentPage
	| ISetIDForDeletion
	| ISetIDForFullInfo
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
